import PageBody from "./PageBody";
export { PageBody };
export default PageBody;
